import { render, staticRenderFns } from "./alldistrictList.vue?vue&type=template&id=27466fee"
import script from "./alldistrictList.vue?vue&type=script&lang=js"
export * from "./alldistrictList.vue?vue&type=script&lang=js"
import style0 from "./alldistrictList.vue?vue&type=style&index=0&id=27466fee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports